//
// WARNING
//
// Do not make manual changes to this file.
// This file was generated by scripts/generate-icons.js.
//
// Generated from: shoppingcart.svg
//

import React from 'react';
import cs from 'classnames';
export function ShoppingcartIcon(props) {
  return /*#__PURE__*/React.createElement("svg", {
    className: cs('Icon', 'Icon--shoppingcart', props.className),
    style: props.style,
    "aria-hidden": props.title ? undefined : true,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64"
  }, props.title && /*#__PURE__*/React.createElement("title", null, props.title), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M47.44 44a6 6 0 005.82-4.54L57.88 21A4 4 0 0054 16H17.24l-1-4.78A4 4 0 0012.36 8H6a2 2 0 100 4h6.36l7.3 36.48a6 6 0 108 7.52h14.7a6 6 0 100-4H27.65a6 6 0 00-4-3.75L22.84 44h24.6zM54 20l-4.62 18.49A2 2 0 0147.44 40H22l-4-20h36zM22 56a2 2 0 110-4 2 2 0 110 4zm26-4a2 2 0 110 4 2 2 0 010-4z"
  }));
}